import { makeStyles, tokens } from "@fluentui/react-components";

export const useReplyCarouselStyles = makeStyles({
  carousel: {
    boxShadow: tokens.shadow16,
    paddingBottom: "16px",
    paddingLeft: "8px",
    paddingRight: "8px",
  },
  carouselContent: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    margin: "8px",
  },
  carouselCard: {
    display: "flex",
    flexDirection: "column",
  },
  viewport: {
    overflow: "hidden",
    width: "100%",
  },
  skeleton: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalL,
  },
  suggestion: {
    whiteSpace: "break-spaces",
  },
  insertTextBtn: {
    marginTop: "auto",
    width: "fit-content",
  },
});
